import axios from "axios";
import { Config } from "../core/config/config";
import * as ts from "typescript"
export interface CompilationResult {
    code?: string;
    diagnostics: ts.Diagnostic[]
};

export class TypescriptCompiler {
    private typescriptLibs;
    private systemSettings: any = {
        useCaseSensitiveFileNames: false,
        args: [],
        newLine: "\n",
        getExecutingFilePath: () => "",
        getCurrentDirectory: () => "",
        directoryExists: () => true,
        getDirectories: () => []
    };

    public Init = async () => {
        const lib = (await axios.get(Config.baseUrl + "react_app/typeinfo/typescript/lib.d.txt")).data;
        const libEs5 = (await axios.get(Config.baseUrl + "react_app/typeinfo/typescript/lib.es5.d.txt")).data;
        const libdom = (await axios.get(Config.baseUrl + "react_app/typeinfo/typescript/lib.dom.d.txt")).data;
        const scripthost = (await axios.get(Config.baseUrl + "react_app/typeinfo/typescript/lib.scripthost.d.txt")).data;
        const webworkerimportscripts = (await axios.get(Config.baseUrl + "react_app/typeinfo/typescript/lib.webworker.importscripts.d.txt")).data;

        this.typescriptLibs = {
            "lib.d.ts": ts.createSourceFile("lib.d.ts", lib, ts.ScriptTarget.ES2015),
            "lib.es5.d.ts": ts.createSourceFile("lib.es5.d.ts", libEs5, ts.ScriptTarget.ES2015),
            "lib.dom.d.ts": ts.createSourceFile("lib.dom.d.ts", libdom, ts.ScriptTarget.ES2015),
            "lib.scripthost.d.ts": ts.createSourceFile("lib.scripthost.d.ts", scripthost, ts.ScriptTarget.ES2015),
            "lib.webworker.importscripts.d.ts": ts.createSourceFile("lib.webworker.importscripts.d.ts", webworkerimportscripts, ts.ScriptTarget.ES2015)
        };
    }

    getTypescriptDiagnostics = (code: string, libs: string[]): CompilationResult => {
        Object.assign(ts.sys, this.systemSettings);
        const dummyFilePath = "/in-memory-file.ts";
        const dummySourceFile = ts.createSourceFile(dummyFilePath, code, ts.ScriptTarget.ES2015);

        var { outputCode, diagnostics }: { outputCode: string; diagnostics: ts.Diagnostic[]; } = this.getDiagnostics(dummyFilePath, dummySourceFile, code);

        return { code: outputCode, diagnostics: diagnostics };
    }

    getJsDiagnostics = (code: string, libs: string[]): CompilationResult => {
        Object.assign(ts.sys, this.systemSettings);
        const dummyFilePath = "/in-memory-file.js";
        const dummySourceFile = ts.createSourceFile(dummyFilePath, code, ts.ScriptTarget.ES2015);

        var { outputCode, diagnostics }: { outputCode: string; diagnostics: ts.Diagnostic[]; } = this.getDiagnostics(dummyFilePath, dummySourceFile, code, true);

        return { code: outputCode, diagnostics: diagnostics };
    }

    transpileToEs5 = (code: string): string => {
        const options = ts.getDefaultCompilerOptions();
        options.allowJs = true;
        options.target = ts.ScriptTarget.ES5;
        return ts.transpile(code, options);
    }

    transpileTsxToEs6 = (code: string): string => {
        const options = ts.getDefaultCompilerOptions();
        options.allowJs = true;
        options.target = ts.ScriptTarget.ES2016;
        options.jsx = ts.JsxEmit.React;
        //options.sourceMap = true;
        //options.inlineSourceMap = true; 
        return ts.transpile(code, options, 'main.tsx');
    }

    private getDiagnostics(dummyFilePath: string, dummySourceFile: ts.SourceFile, code: string, allowJs: boolean = false) {
        const options = ts.getDefaultCompilerOptions();
        if (allowJs) {
            options.allowJs = true;
        }
        options.strictNullChecks = true;
        const realHost = ts.createCompilerHost(options, true);
        let outputCode: string;
        const host: ts.CompilerHost = {
            fileExists: filePath => filePath === dummyFilePath || realHost.fileExists(filePath),
            directoryExists: realHost.directoryExists && realHost.directoryExists.bind(realHost),
            getCurrentDirectory: realHost.getCurrentDirectory.bind(realHost),
            getDirectories: realHost.getDirectories.bind(realHost),
            getCanonicalFileName: fileName => realHost.getCanonicalFileName(fileName),
            getNewLine: realHost.getNewLine.bind(realHost),
            getDefaultLibFileName: realHost.getDefaultLibFileName.bind(realHost),
            getSourceFile: (fileName, languageVersion, onError, shouldCreateNewSourceFile) => fileName === dummyFilePath
                ? dummySourceFile
                : this.typescriptLibs[fileName],
            readFile: filePath => filePath === dummyFilePath
                ? code
                : realHost.readFile(filePath),
            useCaseSensitiveFileNames: () => realHost.useCaseSensitiveFileNames(),
            writeFile: (fileName, data) => outputCode = data,
        };
        const rootNames = [];
        const program = ts.createProgram(rootNames.concat([dummyFilePath]), options, host);
        //const emitResult = program.emit();
        const diagnostics = ts.getPreEmitDiagnostics(program).slice();
        return { outputCode, diagnostics };
    }
}


